import {
  CreateMedicalEquipmentDto,
  EquipmentService,
  UpdateMedicalEquipmentDto,
} from '@services/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '@state/actions'

interface EquipmentQueryParams {
  page?: number
  limit?: number
  search?: string
  type?: string
}

export const findAllMedicalEquipment = createAsyncThunk(
  'medicalEquipment/findAll',
  async (params: EquipmentQueryParams = {}, { rejectWithValue }) => {
    try {
      const response = await EquipmentService.findAllMedicalEquipment(params)
      return response
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message)
    }
  },
)

export const updateMedicalEquipment = createAsyncThunk(
  Actions.MEDICAL_EQUIPMENT_UPDATE,
  async (
    { id, body }: { id: number; body: UpdateMedicalEquipmentDto },
    { rejectWithValue },
  ) => {
    try {
      return await EquipmentService.updateMedicalEquipment({ id, body })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
export const createMedicalEquipment = createAsyncThunk(
  Actions.MEDICAL_EQUIPMENT_CREATE,
  async (body: CreateMedicalEquipmentDto, { rejectWithValue }) => {
    try {
      return await EquipmentService.createMedicalEquipment({ body })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
export const deleteMedicalEquipment = createAsyncThunk(
  Actions.MEDICAL_EQUIPMENT_DELETE,
  async (id: number, { rejectWithValue }) => {
    try {
      return await EquipmentService.removeMedicalEquipment(id)
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const deleteBulkMedicalEquipment = createAsyncThunk(
  Actions.MEDICAL_EQUIPMENT_BULK_DELETE,
  async (ids: number[], { rejectWithValue }) => {
    try {
      return await EquipmentService.removeBulkMedicalEquipment(ids)
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)